/**
 * halo-filter-apply.js
 * Replaces instant-filter behaviour with an "Apply Filters" button.
 * Works on all devices and does not touch any theme JS.
 */
(function () {
  function init() {
    var sidebar = document.getElementById('halo-sidebar');
    if (!sidebar) return;

    var form = document.getElementById('CollectionFiltersForm');
    if (!form) return;

    // --- 1. Inject Apply button at bottom of sidebar ---
    if (!document.getElementById('halo-apply-filters-btn')) {
      var btnWrap = document.createElement('div');
      btnWrap.id = 'halo-apply-filters-wrap';
      btnWrap.innerHTML =
        '<button id="halo-apply-filters-btn" type="button">Apply Filters</button>';
      sidebar.appendChild(btnWrap);
    }

    // --- 2. Style the button ---
    var style = document.getElementById('halo-apply-btn-style');
    if (!style) {
      style = document.createElement('style');
      style.id = 'halo-apply-btn-style';
      style.textContent = [
        '#halo-apply-filters-wrap {',
        '  position: sticky;',
        '  bottom: 0;',
        '  background: #fff;',
        '  padding: 12px 16px;',
        '  border-top: 1px solid #e8e8e8;',
        '  z-index: 10;',
        '}',
        '#halo-apply-filters-btn {',
        '  display: block;',
        '  width: 100%;',
        '  padding: 13px 20px;',
        '  background: #232323;',
        '  color: #fff;',
        '  font-size: 14px;',
        '  font-weight: 600;',
        '  letter-spacing: 0.5px;',
        '  text-transform: uppercase;',
        '  border: none;',
        '  cursor: pointer;',
        '  border-radius: 2px;',
        '}',
        '#halo-apply-filters-btn:hover { background: #444; }'
      ].join('');
      document.head.appendChild(style);
    }

    // --- 3. On Apply click: build URL from form and navigate ---
    document.getElementById('halo-apply-filters-btn').onclick = function () {
      var params = new URLSearchParams();
      var inputs = form.querySelectorAll('input, select');
      inputs.forEach(function (el) {
        if (!el.name) return;
        if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
        if (el.value === '') return;
        params.append(el.name, el.value);
      });
      var qs = params.toString();
      window.location.href = window.location.pathname + (qs ? '?' + qs : '');
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
